import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';

import { ColorEnvironment, Font, Flexbox } from './Styles';

const styles = StyleSheet.create({
  categoryCard: {
    width: 250,
    height: 220,
    borderRadius: 10,
    cursor: 'pointer',
    marginTop: 20,
    paddingLeft: 15,
    paddingRight: 15,
    paddingBottom: 20,
    boxShadow: '0px 0px 8px 6px rgba(0, 0, 0, 0.1)',
    '@media (max-width: 420px)': {
      height: 80,
      paddingTop: 20,
      paddingBottom: 20
    }
  }
});

class CategoryCard extends Component {
  render() {
    return(
      <div className={css(Flexbox.column, Flexbox.axisCenter, Flexbox.crossCenter, ColorEnvironment.inverse, Font.cardHero, styles.categoryCard)} onClick={this.handleSelect.bind(this)}>
        <div className={css(Flexbox.centeredItem)}>
          {this.props.category}
        </div>
      </div>
    );
  }

  handleSelect() {
    this.props.onSelect();
  }
}

export default CategoryCard;



// WEBPACK FOOTER //
// ./src/CategoryCard.js